import { render } from "./projectForm.vue?vue&type=template&id=d9c593e2&scoped=true"
import script from "./projectForm.vue?vue&type=script&lang=js"
export * from "./projectForm.vue?vue&type=script&lang=js"

import "./projectForm.vue?vue&type=style&index=0&id=d9c593e2&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9c593e2"]])

export default __exports__